import { toRaw } from 'vue';

export const cloneVueProxiedObject = <T>(obj: T): T => {
    return structuredClone(toRaw(obj));
};
